/**
 * Purpose: This code encrypts a subscription password using crypto encryption.
 * It takes 'subscriptionPassword' from 'window.subscriptionPassword.subscription_Key', 
 */

// Retrieve the subscription key from the 'subscriptionPassword' property of the 'window' object
var subscriptionPassword = window.subscriptionPassword.subscription_Key;
var md5Pass = null;
// Check if 'subscriptionPassword' is not null
if (subscriptionPassword !== null) {
  // Convert the input string to a WordArray using UTF-8 encoding
  const wordArray = CryptoJS.enc.Utf8.parse(subscriptionPassword);

  // Calculate the MD5 hash
  const md5Hash = CryptoJS.MD5(wordArray);

  // Convert the MD5 hash to a hexadecimal string
  md5Pass = md5Hash.toString(CryptoJS.enc.Hex);

  // At this point, 'encryptedPassword' contains the encrypted version of 'subscriptionPassword'

  // Define a function to prevent the developer menu
  const preventDevMenu = () => {
    // Prevent the context menu from appearing on right-click
    window.addEventListener("contextmenu", (e) => {
      e.preventDefault();
    });

    // Add an event listener for keydown events
    document.onkeydown = (e) => {
      // Check if specific keys are pressed and prevent them if so
      if (
        e.key === 'F12' ||
        e.key === 'Shift' ||
        e.key === 'Meta' ||
        e.key === 'Alt' ||
        e.key === 'Control'
      ) {
        return false; // Prevent the default behavior for these keys
      }
    };
  };

/**
 * Show Overlay
 */
showOverlay=()=>{
  document.getElementById('site-overlay').classList.add('overlay--body');
  document.querySelector('body').classList.add('scroll-fixed');
}
 /**
   * Hide Overlay
   */
  hideOverlay=()=>{
    document.getElementById('site-overlay')?.classList.remove('overlay--body');
  }
  // Call the preventDevMenu function to enable the prevention of the developer menu
  showOverlay();
  preventDevMenu();
}

const passwordModal=document.querySelector('#texas-password-modal')
var texasLogin = sessionStorage.getItem('texas_login');
if (texasLogin == "true") {
  texasLogin = true;
}else{
  texasLogin = false;
}
if (!texasLogin) {
  passwordModal.querySelector('form').addEventListener('submit',(event)=>{
    event.preventDefault();
    let passWord=passwordModal.querySelector('input[name="password"]').value;
  
    // Convert the input string to a WordArray using UTF-8 encoding
    const wordArray = CryptoJS.enc.Utf8.parse(passWord);
  
    // Calculate the MD5 hash
    const md5Hash = CryptoJS.MD5(wordArray);
  
    // Convert the MD5 hash to a hexadecimal string
    const encryptedPassword = md5Hash.toString(CryptoJS.enc.Hex);
  
    console.log(md5Pass,'md5Pass',encryptedPassword)
    if (md5Pass == encryptedPassword) {
      document.querySelectorAll('.shopify-section').forEach((ele)=>{
        ele.style.display="block";
      })
      passwordModal.style.display="none";
      hideOverlay();
      document.querySelector('body')?.classList.remove('scroll-fixed');
      sessionStorage.setItem('texas_login', true);
    }else{
      if(passwordModal.querySelector('.error-text') != null)
        { passwordModal.querySelector('.error-text').style.display="block" }
      }
  })
}else{
  passwordModal.style.display="none";
  hideOverlay();
  document.querySelector('body')?.classList.remove('scroll-fixed');
  document.querySelectorAll('.shopify-section').forEach((ele)=>{
    ele.style.display="block";
  })
}